<template>
  <div>
    <background-wrapper :src="routeNameKebab + '/fullscreen-image_hero'" ext="png">
      <div class="hero">
        <text-container size="lg">
          <h1 class="h2" v-html="$t(`${$route.name}.hero.title`)"/>
          <p v-html="$t(`${$route.name}.hero.subtitle`)"/>
          <b-btn variant="primary" v-scroll-to="{ el: '#subscribe-area', offset: -70 }">{{$t('subscribe')}}</b-btn>
        </text-container>
      </div>
    </background-wrapper>
    <div class="general-post">
      <Post v-if="postsData[0]" :post="postsData[0]" big/>
    </div>
    <background-wrapper color="#F8FCFF" v-if="recommendedPosts.length">
      <div class="recommended">
        <h2 class="h1 mb-3" v-html="$t(`${$route.name}.recommended`)"/>
        <VueSlickCarousel class="recommended__posts" :dots="true" v-bind="settings">
          <Post class="recommended__post" v-for="post in recommendedPosts" :post="post" :key="post.title" vertical/>
        </VueSlickCarousel>
      </div>
    </background-wrapper>
    <div class="posts">
      <div class="posts__categories text-center">
        <p class="h-sub d-inline-block">{{$t(`${$route.name}.read-articles-in`)}}</p>
        &nbsp;
        <b-navbar-nav class="d-inline-flex">
          <b-nav-item-dropdown :text="currentCategory ? categories[currentCategory] : $t(`${$route.name}.all-categories`)" right class="h-sub mb-0">
            <b-dropdown-item :active="!currentCategory" :to="{ ...$route, query: {} }">
              {{$t(`${$route.name}.all-categories`)}}
            </b-dropdown-item>
            <b-dropdown-item v-for="(category, id) of categories" :key="id" :active="id === currentCategory" :to="{ ...$route, query: { category: id } }">
              {{category}}
            </b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </div>
      <div class="posts__header">
        <h2 class="posts__title">{{$t(`${$route.name}.blog-articles`)}}</h2>
      </div>
      <div id="posts" class="posts__list">
        <Post v-for="post in postsPerPage" :post="post" :key="post.id"/>
      </div>
      <b-pagination-nav class="pagination" :link-gen="linkGen" :number-of-pages="numberOfPages" use-router>
        <template #first-text>
          <img src="@/assets/arrow-left-small.svg">
          <img src="@/assets/arrow-left-small.svg">
        </template>
        <template #prev-text>
          <img src="@/assets/arrow-left-small.svg">
        </template>
        <template #next-text>
          <img src="@/assets/arrow-right-small.svg">
        </template>
        <template #last-text>
          <img src="@/assets/arrow-right-small.svg">
          <img src="@/assets/arrow-right-small.svg">
        </template>
      </b-pagination-nav>
    </div>
    <background-wrapper :src="routeNameKebab + '/fullscreen-image_subscribe'" ext="png">
      <div class="subscribe subscribe-hs-area" id="subscribe-area">
        <text-container size="lg" align-center justify-center>
          <h2 class="h2" v-html="$t(`${$route.name}.subscribe.title`)"/>
          <div id="hubspotForm" v-once />
        </text-container>
      </div>
    </background-wrapper>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import { Post } from '@/components/ui/blog'

export default {
  name: 'Blog',
  data () {
    return {
      postsData: [],
      recommendedPosts: [],
      perPage: 6,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        speed: 1000,
        responsive: [
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      }
    }
  },
  methods: {
    linkGen (pageNum) {
      const category = this.$route.query.category
      return {
        ...this.$route,
        query: {
          ...category && {
            category
          },
          ...pageNum !== 1 && {
            page: pageNum
          }
        }
      }
    }
  },
  computed: {
    categories () {
      return [...new Set(this.postsData.map(post => post.category))].sort((a, b) => a.localeCompare(b)).reduce((acc, name, index) => ({ ...acc, [index + 1]: name }), {})
    },
    routeNameKebab () {
      return this.$toKebabCase(this.$route.name)
    },
    currentCategory () {
      return this.$route.query.category || 0
    },
    filteredPosts () {
      return !this.currentCategory ? this.postsData : this.postsData.filter(post => this.categories[this.currentCategory] === post.category)
    },
    currentPage () {
      return this.$route.query.page || 1
    },
    numberOfPages () {
      return Math.ceil(this.filteredPosts.length / this.perPage) || 1
    },
    postsPerPage () {
      return [...this.filteredPosts].splice((this.currentPage - 1) * this.perPage, this.perPage)
    }
  },
  components: { VueSlickCarousel, Post },
  mounted () {
    this.axios.get(`${process.env['CMS_DOMAIN']}/api/blog/posts`)
      .then(data => {
        this.postsData = data.data.sort((a, b) => new Date(b.publishedDate) - new Date(a.publishedDate))
        this.recommendedPosts = this.postsData.slice(1, 4)
      })
      .catch(err => {
        console.log(err)
        this.postsData = []
        this.recommendedPosts = []
      })

    const script = document.createElement('script')
    script.src = 'https://js.hsforms.net/forms/v2.js'
    document.body.appendChild(script)
    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          css: '',
          portalId: '1890515',
          formId: '8295e7a6-d7b2-4566-8cd3-11bdae96c455',
          locale: this.$i18n.locale,
          submitButtonClass: 'hide-input hs-replace  subscribe-btn',
          target: '#hubspotForm'
        })
      }
    })
  }
}
</script>

<style lang="sass" scoped>
.hero
  padding: 100px 0

  +media-breakpoint-down(sm)
    padding: 50px 0

    .text-container
      padding-right: 100px
      text-align: left!important
      justify-items: start!important
  +media-breakpoint-down(xs)
    .text-container
      padding-right: 0
  p
    +media-breakpoint-down(lg)
      width: 80%

.general-post
  padding: 75px 0

.recommended
  padding: 60px 0

  &__posts
    margin: 0 -14px

  &__post
    padding: 0 14px 28px

.posts
  margin: 90px 0 120px

  &__title
    font-size: 1rem
    text-transform: uppercase
    letter-spacing: .8px

  &__list
    border: solid 1px #B8BBC3
    border-left: 0
    border-right: 0

  .dropdown.h-sub
    font-weight: bold

.pagination
  margin-top: 35px
  justify-content: center

.subscribe
  padding: 70px 0 220px
</style>

<style lang="sass">
.pagination
  .page-item
    &:not(.active) .page-link
      border: none
    &.active .page-link
      background-color: transparent
      color: $primary
    .page-link
      font-weight: bold
      color: $dark
    &.disabled
      opacity: .7

.subscribe-hs-area
  .hs-form
    text-align: left
    width: 100%

  .hs-error-msg, .hs-main-font-element
    color: red
    font-size: 14px

  .hs-form-required
    display: none

  .hs-email
    width: 100% !important

  .hs-email input[type='email']
    width: 100% !important
    height: 50px
    border-radius: 4px
    border: 1px solid #dedee2
    padding: 20px

  ul
    padding: 0
    margin: 0
    li
      list-style-type: none
      margin: 0
      padding: 0

  .form-columns-2
    margin: auto

  .form-columns-1
    padding: 20px 0 25px
    max-width: 675px
    font-size: 13px
    line-height: 1.54
    letter-spacing: 0.19px
    color: #28292b
    ul li label
      padding-left: 1em
      text-indent: -1em
      margin-left: 1em
      input[type='checkbox']
        margin-left: -1em
        margin-right: 1em

  .hs-submit
    text-align: center
    input[type='submit']
      width: 160px
      height: 50px
      background-color: #0072e0
      border: 1px solid #0072e0
      border-radius: .25rem
      font-size: 16px
      font-weight: bold
      font-stretch: normal
      font-style: normal
      line-height: 1.25
      letter-spacing: 0.4px
      text-align: center
      color: #ffffff
</style>



// WEBPACK FOOTER //
// src/components/blog/Blog.vue